import { render, staticRenderFns } from "./MobileSelect.vue?vue&type=template&id=fb9f384e&scoped=true"
import script from "./MobileSelect.vue?vue&type=script&lang=js"
export * from "./MobileSelect.vue?vue&type=script&lang=js"
import style0 from "./MobileSelect.vue?vue&type=style&index=0&id=fb9f384e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9f384e",
  null
  
)

export default component.exports